/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  CloudResourcesSortInput,
  CloudResourcesFilterInput,
  useGetCloudResourcesQuery,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort?: CloudResourcesSortInput;
  filter?: CloudResourcesFilterInput;
};

export function useGetCloudResources({ page, limit, sort, filter }: Props) {
  const {
    data: cloudResourcesData,
    loading,
    error,
  } = useGetCloudResourcesQuery({
    variables: {
      page: Number(page),
      limit: Number(limit),
      sort,
      filter,
    },
  });

  const data = cloudResourcesData?.cloudResources?.result || [];
  const count = cloudResourcesData?.cloudResources?.pageInfo?.count || 0;

  return { data, loading, error, count } as const;
}
